import React, { useState, useEffect } from 'react';
import Attendix from '../../Assets/AttendixLogo.svg';
import AttendixDark from '../../Assets/AttendixLogoNav.svg';
import Moon from '../../Assets/Moon.svg';
import Sun from '../../Assets/Sun.svg';
import SelectLanguages from '../LanguageSelector/LanguageSelector';
import { useTranslation } from 'react-i18next';

function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  const [theme, setTheme] = useState("light");
  useEffect(() => {
    const root = document.documentElement;
    theme === 'dark' ? root.classList.add('dark') : root.classList.remove('dark');
  }, [theme]);

  const handleThemeSwitch = () => setTheme(theme === "dark" ? "light" : "dark");
  const { t, i18n } = useTranslation();

  return (
    <nav className={`relative bg-white shadow dark:bg-gray-800 ${i18n.language === 'ar' ? 'rtl' : ''}`}>
      <div className="container px-4 sm:px-6 py-3 mx-auto md:flex md:justify-between md:items-center">
        <div className="flex items-center justify-between">
          <a href="#">
            <img className="w-auto h-6 sm:h-7" src={theme === "dark" ? AttendixDark : Attendix} alt="Attendix Logo" />
          </a>
          <div className="flex md:hidden">
            <button onClick={toggleMenu} type="button" className="text-Eerie-Black dark:text-gray-200 hover:text-Ripe-mango-light dark:hover:text-Ripe-mango-light focus:outline-none focus:text-Ripe-mango-light dark:focus:text-Ripe-mango-light" aria-label={t('toggle menu')}>
              {isOpen ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 8h16M4 16h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
        <div className={`absolute inset-x-0 z-20 w-full px-4 py-2 transition-all duration-300 ease-in-out bg-white dark:bg-gray-800 md:mt-0 md:p-0 md:top-0 md:relative md:opacity-100 md:translate-x-0 md:flex md:items-center md:justify-between ${isOpen ? 'opacity-100' : 'hidden opacity-0 -translate-x-full md:translate-x-0'}`}>
          <div className="flex flex-col px-2 -mx-4 md:flex-row md:mx-0 md:py-0">
            {['Home', 'Features', 'Pricing', 'Our App', 'Our Team', 'Contact Us'].map((item, index) => (
              <a key={index} href={`#${item.replace(' ', '')}`} className="px-2 py-2 text-Eerie-Black transition-colors duration-300 transform rounded-lg dark:text-gray-200 hover:bg-Ripe-mango-light dark:hover:bg-Ripe-mango-light md:mx-2">{t(`Navbar.${item}`)}</a>
            ))}
          </div>
          <div className="flex items-center space-x-4 rtl:space-x-reverse">
            <div className="relative">
              <label htmlFor="theme-switch" className="inline-flex items-center cursor-pointer">
                <img src={Sun} alt="Light Mode" />
                <div className="relative mx-2">
                  <input id="theme-switch" type="checkbox" className="sr-only" onClick={handleThemeSwitch} />
                  <div className="block w-10 h-6 bg-gray-400 rounded-full shadow-inner dark:bg-gray-600"></div>
                  <div className="absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow -translate-x-1 transition-transform duration-300 ease-in-out dark:translate-x-6 dark:bg-gray-800"></div>
                </div>
                <img src={Moon} alt="Dark Mode" />
              </label>
            </div>
            <SelectLanguages />
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
